import AdvancedController from "./advanced-controller";

const CONFIG = {
  slideTime: 5000,
  animationTime: 1000, // when changed adapt in CSS also
};

export default class TeamSliderController extends AdvancedController {
  static targets = ["image"];

  static values = {
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
  };

  connect() {
    super.connect(...arguments);
    setTimeout(this.animateTeamImages.bind(this)); // first slide after half time

    // TODO: use or remove
  }

  animateTeamImages() {
    // hide all images after the sixth image
    this.imageTargets.forEach((div, index) => {
      if (index > 5) {
        div.style.display = "none";
        div.querySelector("img").classList.add("-out");
      }
    });

    //  define amount of shown team member images
    const teamImagesLength = Math.min(6, this.imageTargets.length);

    // Return early if there are no hidden images
    if (this.imageTargets.length <= teamImagesLength) {
      setTimeout(this.animateTeamImages.bind(this), CONFIG.slideTime);
      return;
    }

    //  get random index of hidden team member images
    const hiddenTeamImagesIndex = Math.floor(
      Math.random() * (this.imageTargets.length - teamImagesLength) +
      teamImagesLength
    );

    //  get random index of shown team member images
    const teamImagesIndex = Math.floor(Math.random() * teamImagesLength);

    if (this.imageTargets.length > 1) {
      this.imageTargets.forEach((div, index) => {
        //  if random index of shown team member is the same as index
        if (index === teamImagesIndex) {
          div.classList.add("-active");

          //  swap the img tags of 1 hidden team member & 1 shown team member
          setTimeout(() => {
            div.querySelector("img").classList.add("-out");
            div.append(
              this.imageTargets[hiddenTeamImagesIndex].querySelector("img")
            );
          }, 0);
          setTimeout(() => {
            this.imageTargets[hiddenTeamImagesIndex].append(
              div.querySelector("img:first-of-type")
            );
            div.querySelector("img").classList.remove("-out");
          }, CONFIG.animationTime);
        } else {
          if (div.classList.contains("-active")) {
            div.classList.remove("-active");
          }
        }
      });
      setTimeout(this.animateTeamImages.bind(this), CONFIG.slideTime);
    }
  }
}
